import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { shareReplay, takeUntil, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { LogCategory, LoggerService, LogService, LogType } from '../core/services/logger.service';

@Injectable()
export class CareersService {

    private _reload$ = new Subject<void>();
    private _jobpostings$: Observable<any> = null;    
    private _events$: Observable<any> = null;    


    constructor(
        private http: HttpClient,        
        private logger: LoggerService,
    ) {
        this.log("constructor", null, LogCategory.Constructor);       
    }
    private log(method: string = null, message = null, category: LogCategory = LogCategory.Default): void {
        method = (method) ? '.' + method + '()' : '';
        message = (message) ? message.toString() : '';
        this.logger.try(this.constructor.name + method + ': ' + message, LogType.Service, LogService.Careers, category);
    }

    public get jobpostings$(): Observable<any> {
        if (!this._jobpostings$) {
            this._jobpostings$ = this.http.get<any>(environment.apiUrl + '/careers/jobpostings')
                .pipe(
                    tap((data) => this.log('jobpostings$', 'Fetched career summary', LogCategory.SubscriptionData)),
                    takeUntil(this._reload$),
                    shareReplay(1)
                );
        }
        return this._jobpostings$;
    }

    public get events$(): Observable<any> {
        if (!this._events$) {
            this._events$ = this.http.get<any>(environment.apiUrl + '/careers/events')
                .pipe(
                    tap((data) => this.log('events$', 'Fetched events', LogCategory.SubscriptionData)),
                    takeUntil(this._reload$),
                    shareReplay(1)
                );
        }
        return this._events$;
    }

    public update() {
        this.log('update', 'Job Postings updated');
        this._reload$.next();
        this._jobpostings$ = null;
        this._events$ = null;
    }
}
